<template>
    <el-row class="">
        <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12">
            <div>
            <el-card class="box-card">
                <div slot="header" class="clearfix">
                    <span>ID:{{detail.activityId}}/{{VERSIONS && VERSIONS[detail.vipType]?VERSIONS[detail.vipType].versionName:''}}</span>
                    <el-button style="float: right; padding: 0px 0" type="text">
                        <img :src="'https://assets.pfotoo.com/images/version/'+detail.vipType+'.png'"/>
                    </el-button>
                </div>
                <div class="flex align-center">
                    <el-popover class="hidden-xs-only margin-right"
                            placement="left-end"
                            width="300"
                            trigger="hover">
                        <el-image :src="codeurl">
                            <div slot="placeholder" class="image-slot">
                                加载中<span class="dot">...</span>
                            </div>
                        </el-image>
                        <el-image :src="codeurl" style="width: 100px;" slot="reference">
                            <div slot="placeholder" class="image-slot">
                                加载中<span class="dot">...</span>
                            </div>
                        </el-image>
                    </el-popover>

                    <div>
                        <a :href="'https://pfotoo.com/#/activity/'+detail.aesId" target="_blank">
                            {{detail.activityName}}
                        </a>
                    </div>
                </div>
                <div class="flex align-center justify-between margin-top-sm">
                    <div>活动类型</div>
                    <el-select v-model="detail.activityType" placeholder="请选择" @change="activityTypeChange">
                        <el-option
                                v-for="item in activityTypes"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                        </el-option>
                    </el-select>
                </div>
                <el-switch class="border"
                           @change="enableOption($event,'/admin/activity/banActivity','isBan','GET')"
                           v-model="detail.auditStatus==1"
                           active-text=""
                           inactive-text="封禁活动">
                </el-switch>
            </el-card>
            <el-card class="box-card margin-top-sm">
                <el-collapse v-model="activeNames" @change="handleChange">
                    <el-collapse-item title="素材规则" name="rules">
                        <el-alert v-if="'PictureAndVideo'==detail.activityType"
                                  title="照片+视频 最大总数量请设置照片数量"
                                  type="warning"
                                  :closable="false">
                        </el-alert>
                        <el-form ref="form" :model="limit" label-width="40px">
                            <el-form-item label="照片" v-if="['Picture','PictureAndVideo','Mixin'].includes(detail.activityType)">
                                <el-col :span="11">
                                    <el-input placeholder="请输入" v-model="limit.pictureSize"
                                              @change="materialRuleLimit"
                                              size="mini">
                                        <template slot="append">M</template>
                                    </el-input>
                                </el-col>
                                <el-col :span="2">&nbsp;</el-col>
                                <el-col :span="11">
                                    <el-input placeholder="请输入" v-model="limit.pictureCount"
                                              @change="materialRuleLimit"
                                              size="mini">
                                        <template slot="append">个</template>
                                    </el-input>
                                </el-col>
                                <el-col :span="10" style="line-height: normal;">
                                    <el-switch class="border" @change="enableOriginVideo($event,'/admin/activity/enableOriginPicture')"
                                               v-model="rulePicture.isOrigin==1"
                                               active-text=""
                                               inactive-text="原图">
                                    </el-switch>
                                </el-col>
                            </el-form-item>
                            <el-form-item label="视频" v-if="['Video','PictureAndVideo','Mixin'].includes(detail.activityType)">
                                <el-col :span="11">
                                    <el-input placeholder="请输入" v-model="limit.videoSize"
                                              @change="materialRuleLimit"
                                              size="mini">
                                        <template slot="append">M</template>
                                    </el-input>
                                </el-col>
                                <el-col :span="2">&nbsp;</el-col>
                                <el-col :span="11">
                                    <el-input placeholder="请输入" v-model="limit.videoDuration"
                                              @change="materialRuleLimit"
                                              size="mini">
                                        <template slot="append">分钟</template>
                                    </el-input>
                                </el-col>
                                <el-col :span="11">
                                    <el-input placeholder="请输入" v-model="limit.videoCount"
                                              @change="materialRuleLimit"
                                              size="mini">
                                        <template slot="append">个</template>
                                    </el-input>
                                </el-col>
                                <el-col :span="2">&nbsp;</el-col>
                                <el-col :span="10" style="line-height: normal;">
                                    <el-switch class="border" @change="enableOriginVideo($event,'/admin/activity/enableOriginVideo')"
                                               v-model="ruleVideo.isOrigin==1"
                                               active-text=""
                                               inactive-text="原视频">
                                    </el-switch>
                                </el-col>
                            </el-form-item>
                            <el-form-item label="文档" v-if="['Document','Mixin'].includes(detail.activityType)">
                                <el-col :span="11">
                                    <el-input placeholder="请输入" v-model="limit.docSize"
                                              @change="materialRuleLimit"
                                              size="mini">
                                        <template slot="append">M</template>
                                    </el-input>
                                </el-col>
                                <el-col :span="2">&nbsp;</el-col>
                                <el-col :span="11">
                                    <el-input placeholder="请输入" v-model="limit.docCount"
                                              @change="materialRuleLimit"
                                              size="mini">
                                        <template slot="append">个</template>
                                    </el-input>
                                </el-col>
                            </el-form-item>
                            <el-form-item label="文字" v-if="['Word','Mixin'].includes(detail.activityType)">
                                <el-col :span="11">
                                    <el-input placeholder="请输入" v-model="limit.wordCount"
                                              @change="materialRuleLimit"
                                              size="mini">
                                        <template slot="append">字</template>
                                    </el-input>
                                </el-col>
                            </el-form-item>
                            <el-form-item label="音频" v-if="['Audio','Mixin'].includes(detail.activityType)">
                                <el-col :span="11">
                                    <el-input placeholder="请输入" v-model="limit.audioSize"
                                              @change="materialRuleLimit"
                                              size="mini">
                                        <template slot="append">M</template>
                                    </el-input>
                                </el-col>
                                <el-col :span="2">&nbsp;</el-col>
                                <el-col :span="11">
                                    <el-input placeholder="请输入" v-model="limit.audioDuration"
                                              @change="materialRuleLimit"
                                              size="mini">
                                        <template slot="append">分钟</template>
                                    </el-input>
                                </el-col>
                                <el-col :span="11">
                                    <el-input placeholder="请输入" v-model="limit.audioCount"
                                              @change="materialRuleLimit"
                                              size="mini">
                                        <template slot="append">个</template>
                                    </el-input>
                                </el-col>
                            </el-form-item>
                        </el-form>
                    </el-collapse-item>
                    <el-collapse-item title="功能开通" name="function">
                        <el-descriptions class="margin-top-xl" title="权益列表" :column="1" size="mini" border>
                            <el-descriptions-item>
                                <template slot="label">
                                    <el-select v-model="equityKey" filterable placeholder="请选择">
                                        <el-option
                                                v-for="item in equitys"
                                                :key="item.key"
                                                :label="item.label"
                                                :value="item.key">
                                            <span :class="item.value==1?'text-green el-icon-success':'text-red el-icon-error'"></span>
                                            <span>{{ item.label }}</span>
                                        </el-option>
                                    </el-select>
                                </template>
                                <el-switch class="border"
                                           @change="enableOption($event,'/admin/activity/modifyActivityAuthData',equityKey,'POST')"
                                           v-model="detail.activityAuth[equityKey]==1"
                                           active-text=""
                                           inactive-text="">
                                </el-switch>
                            </el-descriptions-item>
                        </el-descriptions>
                        <el-descriptions class="margin-top-xl" title="版本权益开通" :column="1" size="mini" border>
                            <el-descriptions-item>
                                <template slot="label">
                                    <i class="el-icon-s-grid"></i>
                                </template>
                                <el-switch class="border"
                                           @change="enableOption($event,'/admin/activity/modifyActivityAuthData','openBackgroundMusic','POST')"
                                           v-model="detail.activityAuth.openBackgroundMusic==1"
                                           active-text=""
                                           inactive-text="开通背景音乐">
                                </el-switch>
                                <el-switch class="border"
                                           @change="enableOption($event,'/admin/activity/modifyActivityAuthData','openSubmissionCard','POST')"
                                           v-model="detail.activityAuth.openSubmissionCard==1"
                                           active-text=""
                                           inactive-text="开通填写项卡片">
                                </el-switch>
                                <el-switch class="border"
                                           @change="enableOption($event,'/admin/activity/modifyActivityAuthData','openChooseSelect','POST')"
                                           v-model="detail.activityAuth.openChooseSelect==1"
                                           active-text=""
                                           inactive-text="开通评委选项表单">
                                </el-switch>
                                <el-switch class="border"
                                           @change="enableOption($event,'/admin/activity/modifyActivityAuthData','openTrack','POST')"
                                           v-model="detail.activityAuth.openTrack==1"
                                           active-text=""
                                           inactive-text="开通分组">
                                </el-switch>
                                <el-switch class="border"
                                           @change="enableOption($event,'/admin/activity/modifyActivityAuthData','openTag','POST')"
                                           v-model="detail.activityAuth.openTag==1"
                                           active-text=""
                                           inactive-text="开通征稿单元">
                                </el-switch>
                                <el-switch class="border"
                                           @change="enableOption($event,'/admin/activity/modifyActivityAuthData','openHideVote','POST')"
                                           v-model="detail.activityAuth.openHideVote==1"
                                           active-text=""
                                           inactive-text="开通隐藏票数">
                                </el-switch>
                                <el-switch class="border"
                                           @change="enableOption($event,'/admin/activity/modifyActivityAuthData','openWatermark','POST')"
                                           v-model="detail.activityAuth.openWatermark==1"
                                           active-text=""
                                           inactive-text="开通明水印">
                                </el-switch>
                                <el-switch class="border"
                                           @change="enableOption($event,'/admin/activity/modifyActivityAuthData','openAllowSearch','POST')"
                                           v-model="detail.activityAuth.openAllowSearch==1"
                                           active-text=""
                                           inactive-text="开通搜索">
                                </el-switch>
                            </el-descriptions-item>
                        </el-descriptions>
                        <el-descriptions class="" title="活动范围" :column="1" size="mini" border>
                            <el-descriptions-item>
                                <template slot="label">
                                    <i class="el-icon-crop"></i>
                                </template>
                                <el-checkbox-group v-model="verifyOption" @change="verifyOptionChange" size="mini">
                                    <template v-for="vLabel in verifyOptionLable">
                                        <el-checkbox v-if="vLabel"
                                                     border :label="vLabel" name="verifyOption"></el-checkbox>
                                    </template>
                                </el-checkbox-group>
                            </el-descriptions-item>
                        </el-descriptions>
                        <el-descriptions class="margin-top-xl" title="附件功能" :column="1" size="mini" border>
                            <el-descriptions-item>
                                <template slot="label">
                                    <i class="el-icon-paperclip"></i>
                                </template>
                                <el-input placeholder="提示语"
                                          @change="modifyIsAnnex($event,'enclosureTips')"
                                          v-model="detail.activityAuth.enclosureTips" size="mini">
                                    <template slot="append">
                                        <el-switch @change="modifyIsAnnex($event,'isAnnex')"
                                                   v-model="detail.activityAuth.isAnnex == 1"
                                                   active-text=""
                                                   inactive-text="开通附件">
                                        </el-switch>
                                        <el-switch @change="modifyIsAnnex($event,'mustEnclosure')"
                                                   v-model="detail.activityAuth.mustEnclosure == 1"
                                                   active-text=""
                                                   inactive-text="必填">
                                        </el-switch>
                                    </template>
                                </el-input>
                            </el-descriptions-item>
                        </el-descriptions>
                        <el-descriptions class="margin-top-xl" title="投稿设置" :column="1" size="mini" border>
                            <el-descriptions-item>
                                <template slot="label">
                                    <i class="el-icon-camera"></i>
                                </template>
                                <el-switch class="border" @change="enableAnonymous"
                                           v-model="detail.activityAuth.openAnonymous==1"
                                           active-text=""
                                           inactive-text="匿名">
                                </el-switch>
                                <el-switch class="border" @change="enableEverydaySub"
                                           v-model="detail.activityAuth.openEverydaySub==1"
                                           active-text=""
                                           inactive-text="每天">
                                </el-switch>
                                <el-switch class="border" @change="enablePresetName"
                                           v-model="detail.activityAuth.openPresetName==1"
                                           active-text=""
                                           inactive-text="预设名单">
                                </el-switch>
                                <el-switch class="border" @change="enableOption($event,'/admin/activity/enableSubmissionLimitArea')"
                                           v-model="detail.activityAuth.openSubmissionLimitArea==1"
                                           active-text=""
                                           inactive-text="限定投稿地区">
                                </el-switch>
                                <el-switch class="border"
                                           @change="enableOption($event,'/admin/activity/modifyActivityAuthData','isShowSerialNumber','POST')"
                                           v-model="detail.activityAuth.isShowSerialNumber==1"
                                           active-text=""
                                           inactive-text="展示编号">
                                </el-switch>
                            </el-descriptions-item>
                        </el-descriptions>
                        <el-descriptions class="margin-top-xl"
                                         title="大众评选" :column="1" size="mini" border>
                            <el-descriptions-item>
                                <template slot="label">
                                    <i class="el-icon-star-off"></i>
                                </template>
                                <div>
                                    <el-switch class="border" @change="enableOption($event,'/admin/activity/enableAntiCheat')"
                                               v-model="detail.activityAuth.openAntiCheat==1"
                                               active-text=""
                                               inactive-text="反刷票">
                                    </el-switch>
                                    <el-switch class="border"
                                               @change="enableOption($event,'/admin/activity/modifyActivityAuthData','isShowSerialNumber','POST')"
                                               v-model="detail.activityAuth.isShowSerialNumber==1"
                                               active-text=""
                                               inactive-text="展示编号">
                                    </el-switch>
                                </div>
                                <div class="solid-top padding-top-xs margin-top-xs">
                                    <el-switch class="border" @change="enableOption($event,'/admin/activity/enableAppoint')"
                                               v-model="detail.activityAuth.openAppoint==1"
                                               active-text=""
                                               inactive-text="指定投稿">
                                    </el-switch>
                                    <el-switch class="border" @change="enableOption($event,'/admin/activity/enableGrantMobile')"
                                               v-model="detail.activityAuth.openGrantMobile==1"
                                               active-text=""
                                               inactive-text="授权手机">
                                    </el-switch>

                                    <el-switch class="border" @change="enableOption($event,'/admin/activity/enableVoteLimitArea')"
                                               v-model="detail.activityAuth.openVoteLimitArea==1"
                                               active-text=""
                                               inactive-text="限定投票地区">
                                    </el-switch>
                                    <el-switch class="border" @change="enableOption($event,'/admin/activity/enableHideVote')"
                                               v-model="detail.activityAuth.isHideVote==1"
                                               active-text=""
                                               inactive-text="隐藏票数">
                                    </el-switch>
                                    <el-switch class="border" @change="enableOption($event,'/admin/activity/enableDailyRanking')"
                                               v-model="detail.activityAuth.openDailyRanking==1"
                                               active-text=""
                                               inactive-text="每日排行">
                                    </el-switch>
                                </div>
                                <div class="solid-top padding-top-xs margin-top-xs">
                                    <el-switch class="border" @change="enableOption($event,'/admin/activity/enablePk')"
                                               v-model="detail.activityAuth.openPk==1"
                                               active-text=""
                                               inactive-text="开通PK赛">
                                    </el-switch>
                                </div>
                            </el-descriptions-item>
                        </el-descriptions>
                        <el-descriptions class="margin-top-xl" title="其它功能" :column="1" size="mini" border>
                            <el-descriptions-item>
                                <template slot="label">
                                    <i class="el-icon-magic-stick"></i>
                                </template>
                                <el-switch class="border" @change="enableOption($event,'/admin/activity/openResultQuery')"
                                           v-model="detail.activityAuth.openResultQuery==1"
                                           active-text=""
                                           inactive-text="结果查询">
                                </el-switch>
                                <el-switch class="border" @change="adSetting"
                                           v-model="detail.activityAuth.isAdvertisement==1"
                                           active-text=""
                                           inactive-text="去广告">
                                </el-switch>
                                <el-switch class="border" @change="restrictAccess"
                                           v-model="detail.activityAuth.isRestrictAccess==1"
                                           active-text=""
                                           inactive-text="专属活动">
                                </el-switch>
                                <el-switch class="border"
                                           @change="enableOption($event,'/admin/activity/modifyActivityAuthData','openPrivacyActivity','POST')"
                                           v-model="detail.activityAuth.openPrivacyActivity==1"
                                           active-text=""
                                           inactive-text="禁止分享活动">
                                </el-switch>
                                <el-switch class="border"
                                           @change="enableOption($event,'/admin/activity/modifyActivityAuthData','openPrivacySubmission','POST')"
                                           v-model="detail.activityAuth.openPrivacySubmission==1"
                                           active-text=""
                                           inactive-text="禁止分享投稿">
                                </el-switch>
                                <el-switch class="border" @change="publicSetting"
                                           v-model="detail.activityAuth.isPublic==1"
                                           active-text=""
                                           inactive-text="公开征集">
                                </el-switch>
                            </el-descriptions-item>
                        </el-descriptions>
                        <el-descriptions class="margin-top-xl" :column="1" size="mini" border>
                            <template slot="title">
                                <div class="flex align-center" style="width:100%;">
                                    <span>活动置顶</span>
                                    <el-link type="primary" :underline="false" style="margin-left:auto;" @click="gotoPinnedList">置顶活动列表</el-link>
                                </div>
                            </template>
                            <el-descriptions-item>
                                <template slot="label">
                                    <i class="el-icon-top"></i>
                                </template>
                                <el-switch class="border"
                                           @change="pinFormChange"
                                           v-model="pinForm.isPinned"
                                           :active-value="1" :inactive-value="0"
                                           active-text="置顶开关" inactive-text="置顶开关">
                                </el-switch>
                                <div class="margin-top-sm">
                                    <span class="margin-right">开始时间</span>
                                    <el-date-picker size="mini"
                                                    v-model="pinForm.pinnedStartTime"
                                                    type="datetime"
                                                    value-format="yyyy-MM-dd HH:mm:ss"
                                                    placeholder="选择开始时间"
                                                    @change="pinFormChange"
                                                    :disabled="pinForm.isPinned != 1"
                                                    style="width: 200px;">
                                    </el-date-picker>
                                </div>
                                <div class="margin-top-sm">
                                    <span class="margin-right">结束时间</span>
                                    <el-date-picker size="mini"
                                                    v-model="pinForm.pinnedEndTime"
                                                    type="datetime"
                                                    value-format="yyyy-MM-dd HH:mm:ss"
                                                    placeholder="选择结束时间"
                                                    @change="pinFormChange"
                                                    :picker-options="pinEndPickerOptions"
                                                    :disabled="pinForm.isPinned != 1"
                                                    style="width: 200px;">
                                    </el-date-picker>
                                </div>
                                <div class="margin-top-sm">
                                    <span class="margin-right">置顶位置</span>
                                    <el-select size="mini"
                                               v-model="pinForm.orderNum"
                                               placeholder="请选择"
                                               @change="pinFormChange"
                                               :disabled="pinForm.isPinned != 1"
                                               style="width: 200px;">
                                        <el-option v-for="p in pinPositions"
                                                   :key="p.value" :label="p.label" :value="p.value">
                                        </el-option>
                                    </el-select>
                                </div>
                                <div class="margin-top-sm flex align-center">
                                    <el-button type="primary" size="mini"
                                               :disabled="!pinDirty"
                                               @click="savePinned">保存置顶设置</el-button>
                                    <el-tag size="mini" :type="pinStatusTagType" style="margin-left: 10px;">
                                        {{ pinStatusText }}
                                    </el-tag>
                                </div>
                            </el-descriptions-item>
                        </el-descriptions>
                        <el-form ref="form" :model="form" label-width="80px">

                            <el-row style="padding: 0 0px 20px 10px;">
                                <el-col :span="7">

                                </el-col>
                                <el-col :span="8">

                                </el-col>
                                <el-col :span="9">

                                </el-col>
                                <el-col :span="8">

                                </el-col>
                            </el-row>
                        </el-form>
                    </el-collapse-item>
                </el-collapse>
            </el-card>
        </div>
        </el-col>
        <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12">
            <div>
                <el-card class="box-card">
                    <el-collapse v-model="activeNames" @change="handleChange">
                        <el-collapse-item title="工具箱" name="tools">
                            <div class="flex flex-wrap">
                                <el-popover style="margin-right: 10px;"
                                        placement="right"
                                        width="375"
                                        trigger="click">
                                    <div v-if="detail.activityCovers" class="flex flex-direction align-center">
                                        <a :href="detail.activityCovers[0].url" target="_blank">{{detail.activityCovers[0].url}}</a>
                                        <iframe :src="(detail.activityCovers[0].url).replace(/[^:]+:/,'')+'?imageInfo'" style="width: 100%;height: 100px;"></iframe>
                                        <div class="text-red margin-bottom">请填写上面真实宽高到下方</div>
                                        <el-input placeholder="请输入"
                                                  v-model="detail.width" size="mini">
                                            <template slot="append">当前宽度 {{detail.activityCovers[0].width}}</template>
                                        </el-input>
                                        <el-input placeholder="请输入"
                                                  v-model="detail.height" size="mini">
                                            <template slot="append">当前高度 {{detail.activityCovers[0].height}}</template>
                                        </el-input>
                                        <div class="margin-top-xl">
                                            <el-button type="success"
                                                       @click="fixThumb"
                                                       size="mini">
                                                <span class="el-icon-s-help">修复封面</span>
                                            </el-button>
                                        </div>
                                    </div>
                                    <el-button slot="reference" type="success"
                                               size="mini">
                                        修复封面
                                    </el-button>
                                </el-popover>
                                <el-button type="success"
                                           @click="enableOption($event,'/admin/activity/cleanPopularVote')"
                                           size="mini">
                                    清理投票
                                </el-button>
                                <el-button type="success"
                                           @click="enableOption($event,'/admin/submission/rearrangeSerialNumber')"
                                           size="mini">
                                    重置编号
                                </el-button>
                                <el-button type="success"
                                           @click="enableOption($event,'/admin/submission/syncSubmissionCardData')"
                                           size="mini">
                                    同步卡片
                                </el-button>
                                <el-button type="success"
                                           @click="enableOption(1,'/admin/activity/thawFile','type','POST')"
                                           size="mini">
                                           ① 打包：解冻文件
                                </el-button>
                                <el-button type="success"
                                           @click="enableOption(2,'/admin/activity/thawFile','type','POST')"
                                           size="mini">
                                           ② 打包：修复文件
                                </el-button>
                            </div>
                        </el-collapse-item>
                        <el-collapse-item title="其它" name="other">
                            <el-form ref="form" :model="form" label-width="70px">
                                <el-form-item label="下载额度" v-if="detail.createBy">
                                    <addDialog ref="addDialog"
                                               :userId="detail.createBy"
                                               @event="addDialogEvent">
                                        <el-button type="primary" size="small">{{MG(detail.residualDownloadTraffic/1)}} <i class="el-icon-download el-icon--right"></i></el-button>
                                    </addDialog>
                                </el-form-item>
                                <el-form-item label="协作数量">
                                    <el-input placeholder="请输入"
                                              @change="modifyCollaboratorLimit"
                                              v-model="detail.activityAuth.collaboratorCount" size="mini">
                                        <template slot="append">个</template>
                                    </el-input>
                                </el-form-item>
                                <el-form-item label="评委数量">
                                    <el-input placeholder="请输入"
                                              @change="modifyJudgesLimit"
                                              v-model="detail.activityAuth.judgesCount" size="mini">
                                        <template slot="append">位</template>
                                    </el-input>
                                </el-form-item>
                                <el-input placeholder="请输入浏览数量"
                                          @change="modifyValue($event,'views','/admin/activity/modifyActivityViews')"
                                          v-model="detail.browse__" size="mini">
                                    <template slot="append">浏览{{detail.browse}}次</template>
                                </el-input>
                                <el-input placeholder="请输入封面数量"
                                          @change="modifyValue($event,'count','/admin/activity/modifyActivityCoverCount')"
                                          v-model="detail.coverCount" size="mini">
                                    <template slot="append">{{detail.activityAuth.coverCount}}个封面</template>
                                </el-input>
                                <el-input placeholder="请输入评委最大数量"
                                          @change="modifyValue($event,'count','/admin/activity/modifyJudgesLimit')"
                                          v-model="detail.judgesCount" size="mini">
                                    <template slot="append">{{detail.activityAuth.judgesCount}}位评委</template>
                                </el-input>
                                <el-input placeholder="请输入协作员最大数量"
                                          @change="modifyValue($event,'count','/admin/activity/modifyCollaboratorLimit')"
                                          v-model="detail.collaboratorCount" size="mini">
                                    <template slot="append">{{detail.activityAuth.collaboratorCount}}位协作员</template>
                                </el-input>
                                <el-input placeholder="请输入管理员最大数量"
                                          @change="modifyValue($event,'managerCount','/admin/activity/modifyActivityAuthData','POST')"
                                          v-model="detail.managerCount" size="mini">
                                    <template slot="append">{{detail.activityAuth.managerCount}}位管理员</template>
                                </el-input>
                            </el-form>
                        </el-collapse-item>
                        <el-collapse-item title="活动定制" name="customize">
                            <a href="https://playcode.io/1503437" target="_blank">最新参数集合&nbsp;&nbsp;&nbsp;&nbsp;</a>
                            <a href="https://codebeautify.org/json-fixer/y23c7be6e" target="_blank">定制参数JSON工具</a>
                            <el-form ref="form" :model="form" label-width="70px">
                                <el-input placeholder="请输入"
                                          type="textarea" :rows="10"
                                          @change="modifyValue($event,'customize','/admin/activity/modifyActivityBasicData','POST')"
                                          v-model="detail.customize" size="mini">
                                </el-input>
                            </el-form>
                        </el-collapse-item>
                    </el-collapse>
                </el-card>
            </div>
        </el-col>
    </el-row>
</template>
<script>
  import App from '../../util/comfun'
  import addDialog from '../components/traffic/addDialog'
  const verifyOptionLable=['','密码','群','公众号','预设名单']
  const pinPositions=[
    {value:1,label:'第一位'},
    {value:2,label:'第二位'},
    {value:3,label:'第三位'},
    {value:4,label:'第四位'},
    {value:5,label:'第五位'},
    {value:6,label:'第六位'},
    {value:7,label:'第七位'},
    {value:8,label:'第八位'},
    {value:9,label:'第九位'},
    {value:10,label:'第十位'},
  ]
  const equitysLabel = {
    "openPrivacy": "openPrivacy 已废弃",
    "openPrivacyActivity": "禁止分享活动",
    "openPrivacySubmission": "禁止分享投稿",
    "openWatermark": "开通明水印",
    "openSubmissionCard": "开通填写项卡片",
    "openChooseSelect": "开通评委选项表单",
    "openActivityVideoCover": "活动视频封面",
    "openTheme": "活动自定义主题色",
    "openActivityTypeModify": "活动类型修改",
    "openBackgroundMusic": "开通背景音乐",
    "openAppoint": "指定投稿",
    "openGrantMobile": "授权手机",
    "openAnonymous": "匿名",
    "openAntiCheat": "反刷票",
    "openVoteLimitArea": "限定投票地区",
    "openSubmissionLimitArea": "限定投稿地区",
    "openHideVote": "开通隐藏票数",
    "openDailyRanking": "每日排行",
    "openEverydaySub": "每天投稿",
    "openPresetName": "预设名单",
    "openPk": "开通PK赛",
    "openRestrictAccess": "openRestrictAccess 未使用",
    "openTag": "开通征稿单元",
    "openTrack": "开通分组",
    "openResultQuery": "结果查询",
    "openAllowSearch": "开通搜索",
    "openCustomActivityShare": "组织者活动分享diy",
    "openParticipantCustomActivityShare": "参与者活动文案 diy",
    "openCustomSubmissionShare": "组织者投稿分享diy",
    "openParticipantCustomSubmissionShare": "参与者投稿文案 diy",
    "openCustomLogo": "组织者活动LOGO diy",
    "isAdvertisement":"去广告",
    "isRestrictAccess":"专属活动",

  }
  export default {
    components: {
      addDialog,
    },
    props:{
    },
    data () {
      return {
        activeNames: ["tools","other","rules","function","customize"],
        drawer: false,
        detail:{activityAuth:{}},
        limit:{},
        verifyOption:[],
        residualDownloadTraffic:0,
        form:{type:[]},
        ruleVideo:{},
        rulePicture:{},
        codeurl:'',
        detailBrowse:'',
        VERSIONS:{},
        verifyOptionLable:verifyOptionLable,
        pinPositions:pinPositions,
        pinForm:{
          isPinned:0,
          pinnedStartTime:'',
          pinnedEndTime:'',
          orderNum:1,
        },
        pinLoaded:false,
        pinDirty:false,
        activityTypes:[
          {label:"图片",value:"Picture"},
          {label:"视频",value:"Video"},
          {label:"图片+视频",value:"PictureAndVideo"},
          {label:"文字",value:"Word"},
          {label:"文档",value:"Document"},
          {label:"混合",value:"Mixin"},
          {label:"音频",value:"Audio"},
        ],
        equitys:[],
        equityKey:'',
      }
    },
    computed:{
      pinEndPickerOptions(){
        return {
          disabledDate:(time)=>{
            if(!this.pinForm.pinnedStartTime) return false
            let start=App.gettimestamp(this.pinForm.pinnedStartTime)*1000
            return time.getTime() < start
          },
        }
      },
      pinStatusTagType(){
        let t=this.pinStatusText
        if(t=='置顶中') return 'success'
        if(t=='未开始') return 'info'
        if(t=='已结束' || t=='已关闭') return 'danger'
        return ''
      },
      //置顶状态：加载中 / 未设置 / 已关闭 / 未开始 / 置顶中 / 已结束
      pinStatusText(){
        if(!this.pinLoaded) return '加载中'
        if(this.pinForm.isPinned != 1) return this.pinForm.pinnedStartTime ? '已关闭' : '未设置'
        let now=parseInt(new Date()/1000)
        let start=this.pinForm.pinnedStartTime ? App.gettimestamp(this.pinForm.pinnedStartTime) : 0
        let end=this.pinForm.pinnedEndTime ? App.gettimestamp(this.pinForm.pinnedEndTime) : 0
        if(start && now < start) return '未开始'
        if(end && now > end) return '已结束'
        return '置顶中'
      },
    },
    methods:{
      MG:App.MG,
      show(activity){
        this.activity=activity
        this.drawer=true
        setTimeout(()=>{
          this.loading=this.$loading({text:'loading...',target:'.el-drawer'})
        },0)
        this.getDetail()
        this.getVersion()
      },
      handleClose(done){
        done()
      },
      async getVersion(){
        if(!wxlite.VERSIONS){
          let vds=(await App.demand('/activity/version/loadConfigList','GET')).data;
          let vers={};
          vds.forEach(ver=>{
            vers[ver.versionType]=ver
          });
          wxlite.VERSIONS=vers
        }
        this.VERSIONS=wxlite.VERSIONS
      },
      async getDetail(){
        this.verifyOption=[]
        this.getPinnedData()
        let res=await App.demand('/activity/materialRule/limit/{activityId}','GET',{activityId:this.activity.id})
        res.data.videoDuration=Math.ceil(res.data.videoDuration/60)
        res.data.audioDuration=Math.ceil(res.data.audioDuration/60)
        this.limit=res.data
        App.Contribution.GetContributionById({activityId:this.activity.id}).then(async res=>{
          let userRes=await App.demand('/user/info','GET',{
            userId:res.data.createBy,
          })
          res.data.residualDownloadTraffic=userRes.data.residualDownloadTraffic/1

          this.detail=res.data
          let verifyOption=this.detail.activityAuth.verifyOption.split('')
          console.log('verifyOption',verifyOption)
          verifyOption.forEach(idx=>{
            if(!verifyOptionLable[idx]) return;
            this.verifyOption.push(verifyOptionLable[idx])
          })
          if(['Video','PictureAndVideo','Mixin','Picture'].includes(this.detail.activityType)){
            this.detail.activityMaterialTypeRefs.some(rule=>{
              if(rule.activityMaterialType=='Video'){
                this.ruleVideo=rule
              }
              if(rule.activityMaterialType=='Picture'){
                this.rulePicture=rule
              }
            })
          }
          this.setQrcode()
          if(this.loading){
            this.loading.close()
            this.loading=null
          }
          this.setEquitys()
        })
      },
      setEquitys(){
        let equitys=[]
        //let equitysLabel={}
        let keys=Object.keys(this.detail.activityAuth)
        let iskeys=['isAdvertisement','isRestrictAccess']
        let diskeys=['openRestrictAccess','openPrivacy']
        keys.forEach((key)=>{
            if((key.indexOf('open')>-1 || iskeys.includes(key)) && !diskeys.includes(key)){
              equitys.push({
                key:key,
                value:this.detail.activityAuth[key],
                label:equitysLabel[key]||key,
              })
              //equitysLabel[key]='label'
            }
        })
        this.equitys=equitys
        //console.error('this.equitys',this.equitys);
      },
      async setQrcode(){
        this.codeurl=await App.System.Qrcode({
          autoColor:false,
          inHyaline:false,
          lineColor:'0,0,0',
          page:'pages/enter/enter',
          scene:encodeURIComponent('gotopath=/pages/pub/work='+this.detail.activityId),
          width:300,
          appId:this.detail.vipType>20?'wxb85ef06b22c33674':(this.detail.vipType>=5 && this.detail.vipType<10?'wxe15e90f50a8379b7':'wx397090124c858e7c'),
        },'URL')
      },
      verifyOptionChange(opt){
        let val=[0]
        opt.forEach(lab=>{
          val.push(verifyOptionLable.indexOf(lab))
        })
        val.sort()
        console.log('verifyOptionChange',val)
        return App.demand('/admin/activity/modifyVerifyOption','POST',{
          "activityId": this.activity.id,
          "optionList": val
        })
      },
      adSetting(val){
        console.log(val)
        if(!this.hasautoUping) this.loading=this.$loading({text:'设置中...',target:'.el-drawer'})
        return App.demand('/admin/activity/adSetting','POST',{
          "activityId": this.activity.id,
          "conceal": val?1:0,
        }).then(()=>{
          if(!this.hasautoUping) this.getDetail()
        })
      },
      activityTypeChange(val){
        //return console.log('activityTypeChange',val)
        if(!this.hasautoUping) this.loading=this.$loading({text:'设置中...',target:'.el-drawer'})
        App.demand('/activity/modifyActivityType','POST',{
          activityId:this.activity.id,
          activityType:val,
        }).then((res)=>{
          if(!this.hasautoUping) this.getDetail()
        })
      },
      restrictAccess(val){
        this.loading=this.$loading({text:'设置中...',target:'.el-drawer'})
        App.demand('/admin/activity/restrictAccess','GET',{
          "activityId": this.activity.id,
          "enable": val?1:0,
        }).then(()=>{
          this.getDetail()
        })
      },
      publicSetting(val){
        this.loading=this.$loading({text:'设置中...',target:'.el-drawer'})
        App.demand('/admin/activity/publicSetting','GET',{
          activityId:this.activity.id,
          isPublic:val?1:0,
        }).then(()=>{
          this.getDetail()
        })
      },
      trafficAdd(val){
        if(!this.hasautoUping) this.loading=this.$loading({text:'设置中...',target:'.el-drawer'})
        return App.demand('admin/trafficAdd','GET',{
          activityId:this.activity.id,
          traffic:val*1024*1024,
        }).then(()=>{
          if(!this.hasautoUping) this.getDetail()
        })
      },
      async getPinnedData(){
        let res=await App.demand('/admin/activity/pinnedData/{activityId}','GET',{
          activityId:this.activity.id,
        })
        if(res.code!=200) return
        let data=res.data
        this.pinLoaded=true
        if(!data){
          this.pinForm={isPinned:0,pinnedStartTime:'',pinnedEndTime:'',orderNum:1}
        }else{
          // 后端时间为秒级时间戳(可能为字符串)，转成 yyyy-MM-dd HH:mm:ss 供日期组件回填
          let pinTime=ts=>{
            if(!ts) return ''
            let n=Number(ts)
            if(n>1e12) n=Math.floor(n/1000)//兼容13位毫秒时间戳
            return App.unixtoTime(n,'YYYY-MM-DD HH:II:SS')
          }
          this.pinForm={
            isPinned:data.isPinned,
            pinnedStartTime:pinTime(data.pinnedStartTime),
            pinnedEndTime:pinTime(data.pinnedEndTime),
            orderNum:Number(data.orderNum)||1,
          }
        }
        this.pinDirty=false
      },
      pinFormChange(){
        this.pinDirty=true
      },
      gotoPinnedList(){
        this.$router.push('/tools/pinned-activity/'+encodeURIComponent(encodeURIComponent(JSON.stringify(this.options))))
      },
      async savePinned(){
        let f=this.pinForm
        if(f.isPinned==1){
          if(!f.pinnedStartTime) return this.$message.warning('请选择置顶开始时间')
          if(!f.pinnedEndTime) return this.$message.warning('请选择置顶结束时间')
          if(App.gettimestamp(f.pinnedEndTime) <= App.gettimestamp(f.pinnedStartTime)){
            return this.$message.warning('结束时间必须晚于开始时间')
          }
          if(!f.orderNum) return this.$message.warning('请选择置顶位置')
        }
        if(!this.hasautoUping) this.loading=this.$loading({text:'设置中...',target:'.el-drawer'})
        let params={
          activityId:this.activity.id,
          isPinned:f.isPinned,
          pinnedStartTime:f.isPinned==1 ? f.pinnedStartTime : '',
          pinnedEndTime:f.isPinned==1 ? f.pinnedEndTime : '',
          orderNum:f.isPinned==1 ? f.orderNum : 0,
        }
        try{
          let res=await App.demand('/admin/activity/pinnedData/modify','POST',params)
          if(res.code!=200){
            this.loading && this.loading.close()
            return this.$message(res.message)
          }
          this.$message.success('保存成功')
          await this.getPinnedData()
        }catch(e){
          console.log(e)
          this.$message.error('保存失败')
        }finally{
          this.loading && this.loading.close()
          this.loading=null
        }
      },
      materialRuleLimit(){
        if(this.hasautoUping){
          let limitData=JSON.parse(JSON.stringify(this.limit))
          limitData.videoDuration=limitData.videoDuration*60
          limitData.audioDuration=limitData.audioDuration*60
          return App.demand('/admin/activity/materialRuleLimit','POST',limitData)
        }else{
          this.loading=this.$loading({text:'设置中...',target:'.el-drawer'})
          setTimeout(()=>{
            let limitData=JSON.parse(JSON.stringify(this.limit))
            limitData.videoDuration=limitData.videoDuration*60
            limitData.audioDuration=limitData.audioDuration*60
            App.demand('/admin/activity/materialRuleLimit','POST',limitData).then(()=>{
              this.getDetail()
            })
          },800)
        }
      },
      modifyCollaboratorLimit(val){
        if(!this.hasautoUping) this.loading=this.$loading({text:'设置中...',target:'.el-drawer'})
        return App.demand('/admin/activity/modifyCollaboratorLimit','GET',{
          activityId:this.activity.id,
          count:val,
        }).then(()=>{
          if(!this.hasautoUping) this.getDetail()
        })
      },
      modifyJudgesLimit(val){
        if(!this.hasautoUping) this.loading=this.$loading({text:'设置中...',target:'.el-drawer'})
        return App.demand('/admin/activity/modifyJudgesLimit','GET',{
          activityId:this.activity.id,
          count:val,
        }).then(()=>{
          if(!this.hasautoUping) this.getDetail()
        })
      },
      enableOriginVideo(val,uri){
        if(!this.hasautoUping) this.loading=this.$loading({text:'设置中...',target:'.el-drawer'})
        return App.demand(uri,'GET',{
          activityId:this.activity.id,
          enable:val?1:0,
        }).then(()=>{
          if(!this.hasautoUping) this.getDetail()
        })
      },
      enableAnonymous(val){
        if(!this.hasautoUping) this.loading=this.$loading({text:'设置中...',target:'.el-drawer'})
        return App.demand('/admin/activity/enableAnonymous','GET',{
          activityId:this.activity.id,
          enable:val?1:0,
        }).then(()=>{
          if(!this.hasautoUping) this.getDetail()
        })
      },
      enablePresetName(val){
        if(!this.hasautoUping) this.loading=this.$loading({text:'设置中...',target:'.el-drawer'})
        return App.demand('/admin/activity/enablePresetName','GET',{
          activityId:this.activity.id,
          enable:val?1:0,
        }).then(()=>{
          if(!this.hasautoUping) this.getDetail()
        })
      },
      enableEverydaySub(val){
        if(!this.hasautoUping) this.loading=this.$loading({text:'设置中...',target:'.el-drawer'})
        App.demand('/admin/activity/enableEverydaySub','GET',{
          activityId:this.activity.id,
          enable:val?1:0,
        }).then(()=>{
          if(!this.hasautoUping) this.getDetail()
        })
      },
      modifyIsAnnex(val,type){
        this.loading=this.$loading({text:'设置中...',target:'.el-drawer'})
        setTimeout(()=>{
          let isAnnex=this.detail.activityAuth.isAnnex
          let mustEnclosure=this.detail.activityAuth.mustEnclosure
          let params={
            "isAnnex": isAnnex,
            "isEnclosure":isAnnex,
            "enclosureTips": this.detail.activityAuth.enclosureTips||'',
            "mustEnclosure": mustEnclosure,
          }
          if(typeof val=='boolean'){
            params[type]=val?1:0
            params.isEnclosure=params.isAnnex
          }else{
            params[type]=val
          }
          //console.log('modifyIsAnnex',params)
          App.demand('/admin/activity/enclosureOper','POST',{
            "activityId": this.activity.id,
            ...params,
          }).then(()=>{
            this.getDetail()
          })
        },800)
      },
      modifyActivityVipStatus(val){
        if(!this.hasautoUping) this.loading=this.$loading({text:'设置中...',target:'.el-drawer'})
        App.demand('/admin/activity/modifyActivityVipStatus','GET',{
          activityId:this.activity.id,
          isVip:val?1:0,
        }).then(()=>{
          if(!this.hasautoUping) this.getDetail()
        })
      },
      enableOption(enable,api,key='enable',month='GET'){
        if(!this.hasautoUping) this.loading=this.$loading({text:'设置中...',target:'.el-drawer'})
        let val=enable?1:0
        if(typeof enable=='string' || typeof enable=='number'){
          val=enable
        }
        App.demand(api,month,{
          activityId:this.activity.id,
          [key]:val,
        }).then((res)=>{
          if(res.code!=200) {this.loading.close();return this.$message(res.message)}
          if(!this.hasautoUping) this.getDetail()
        }).catch(res=>{
          console.log(res)
          this.loading.close()
          return this.$message(res.status+':'+res.url)
        })
      },
      modifyValue(val,key,api,month='GET'){
        if(!this.hasautoUping) this.loading=this.$loading({text:'设置中...',target:'.el-drawer'})
        return App.demand(api,month,{
          activityId:this.activity.id,
          [key]:val,
        }).then(res=>{
          if(res.code!=200) {this.loading.close();return this.$message(res.message)}
          if(!this.hasautoUping) this.getDetail()
        }).catch(res=>{
          console.log(res)
          this.loading.close()
          return this.$message(res.status+':'+res.url)
        })
      },
      autoUp(){//一键提升vip权益
        this.loading=this.$loading({text:'设置中...',target:'.el-drawer'})
        this.hasautoUping=true
        this.limit={
          activityId: this.limit.activityId,
          audioCount: "2",
          audioDuration: "16",
          audioSize: "100",
          docCount: "2",
          docSize: "100",
          pictureCount: "20",
          pictureSize: "100",
          videoCount: "2",
          videoDuration: "16",
          videoSize: "500",
          wordCount: "5000",
        }
        let autoApi = [
          this.materialRuleLimit(),
          this.modifyCollaboratorLimit(100),//协作员
          this.modifyJudgesLimit(100),//评委数
          this.trafficAdd(102400),//100G
          this.adSetting(1),//ad
          this.verifyOptionChange(['密码', '公众号', '预设名单']),
          this.enableOriginVideo(1),//原视频

          this.enableAnonymous(1),//匿名
          this.enableEverydaySub(1),//每天投稿
          this.enablePresetName(1),//投稿预设名单
          this.enableOption(1, '/admin/activity/enableSubmissionLimitArea'),//限定投稿地区

          this.enableOption(1, '/admin/activity/enableAppoint'),//开通大众投票指定投稿功能
          this.enableOption(1, '/admin/activity/enableGrantMobile'),//开通大众投票授权手机号功能
          this.enableOption(1, '/admin/activity/enableAntiCheat'),//反刷票
          this.enableOption(1, '/admin/activity/enableVoteLimitArea'),//限定投票地区
          this.modifyActivityVipStatus(1),//vip标识
        ]
        Promise.all(autoApi).then(()=>{
          setTimeout(()=>{
            this.hasautoUping=false
            this.getDetail()
          },800)
        }).catch(()=>{
          setTimeout(()=>{
            this.hasautoUping=false
            this.getDetail()
          },800)
        })
      },
      async fixThumb(){
        //"{"type":"1","width":1125,"height":840,"name":"fotoocover","suffix":"","size":0}"
        if(this.detail.activityCovers.length!=1){
          return this.$message('只能修复单封面活动')
        }
        if(!this.hasautoUping) this.loading=this.$loading({text:'修复中...',target:'.el-drawer'})
        let cover=this.detail.activityCovers[0]
        let exif={"type":"1","width":this.detail.width,"height":this.detail.height,"name":cover.fileName||'',"suffix":'',"size":0}
        return App.demand('/activity/cover/save','POST',{
          activityId:this.activity.id,
          coverList:[{
            bucket: "fotoo",
            exif: JSON.stringify(exif),
            fileName: cover.fileName||'',
            hash: "",
            height: this.detail.height,
            id: 0,
            materialType: "PictureMaterialType",
            sequence: 0,
            suffix: '',
            url: cover.url,
            width: this.detail.width,
          },],
        }).then(res=>{
          if(res.code!=200) {this.loading.close();return this.$message(res.message)}
          if(!this.hasautoUping) this.getDetail()
          return this.$message.success('修复成功')
        }).catch(res=>{
          console.log(res)
          this.loading.close()
          return this.$message(res.status+':'+res.url)
        })
      },
      handleChange(){},
      addDialogEvent(e){
        App.demand('/user/info','GET',{
          userId:this.detail.createBy,
        }).then(res=>{
          this.detail.residualDownloadTraffic=res.data.residualDownloadTraffic/1
        })
      },
    },
    mounted(){
      try{
        this.options=JSON.parse(decodeURIComponent(decodeURIComponent(this.$route.params.options)))
        if(this.options.token){
          wxlite.setStorageSync('token',this.options.token)
        }
        console.log('this.options',this.options)
        this.show({id:this.options.activityId})
      }catch(e){}
    },
  }
</script>

<style>
    @import 'element-ui/lib/theme-chalk/display.css';
 .border{
     border: 1px solid #ccc;
     padding: 5px;
     border-radius: 5px;
     margin-right: 5px;
 }
 .el-switch__label{
     white-space:nowrap;
     color: #606266;
 }
 .el-switch__label.is-active{
     color: #606266;
 }
 .el-descriptions__header{
     margin-bottom: 10px;
 }
</style>


// WEBPACK FOOTER //
// src/pages/tools/activity.vue